import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const MessagingListPage = lazy(() => import('./MessagingListPage'));

export const messagingRoutes: RouteObject[] = [
  {
    path: 'messaging',
    element: (
      <ProtectedRoute action="messaging:view">
        <MessagingListPage />
      </ProtectedRoute>
    ),
  },
];
